import logger from "@/plugins/logger";
import { OfflinePermitType } from "models";

const DB_NAME = "zero8db";
const PERMIT_NAME = "permits_";
// let DB_VERSION = 1;

// return new Promise((resolve, reject) => {

// })

const indexedDb = () => {
  let DB: IDBDatabase | null = null;
  const unmountDB = () => {
    // logger.log("Unmount");
    DB = null;
  };
  const getDB = (
    currentUser?: string,
    version?: number
  ): Promise<IDBDatabase | null> => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(DB_NAME, version);
      // logger.log("Waiting for eventListeners now");
      request.onupgradeneeded = (e) => {
        // logger.log("getDB onupgradeneeded");
        const db = (e.target as IDBOpenDBRequest).result;
        // logger.log("Get DB objectStoreNames: ", db.objectStoreNames);
        if (currentUser != undefined) {
          if (
            db.objectStoreNames.contains(PERMIT_NAME + currentUser) == false
          ) {
            // createObjectStore(PERMIT_NAME + currentUser);
            logger.log(
              "Create this:  ",
              PERMIT_NAME + currentUser.toLowerCase()
            );
            const store = db.createObjectStore(
              PERMIT_NAME + currentUser.toLowerCase(),
              {
                autoIncrement: true,
                keyPath: "id",
              }
            );
          }
        }
      };
      request.onblocked = (e) => {
        logger.log("Blocked", e);
      };
      request.onerror = (e) => {
        logger.log("Error opening db", e);
        reject(e);
      };
      request.onsuccess = (e) => {
        if (e == null || e.target == null) {
          logger.log("Db opened succesfully, but null");
          resolve(null);
        } else {
          const db = (e.target as IDBOpenDBRequest).result;
          db.onversionchange = () => {
            db.close();
          };
          resolve(db);
        }
      };
    });
  };
  const getAllUsers = async (): Promise<string[]> => {
    const db = await getDB();
    if (db == null) {
      return Promise.reject("No DB... get stored");
    }
    const items = db.objectStoreNames;
    const empty: string[] = [];
    for (let i = 0; i < items.length; i++) {
      empty.push(items[i].replace(PERMIT_NAME, ""));
    }
    logger.log("Saved DB list: ", items, empty);
    return empty;
  };
  const createObjectStore = async (
    currentUser: string,
    version: number
  ): Promise<IDBDatabase | null> => {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(DB_NAME, version + 1);
      request.onerror = (err) => {
        logger.log("Upgrade error: ", err);
        reject(err);
      };
      request.onupgradeneeded = (up) => {
        logger.log("Please upgrade here :", currentUser.toLowerCase());
        DB = (up.target as IDBOpenDBRequest).result;
        DB.createObjectStore(PERMIT_NAME + currentUser.toLowerCase(), {
          autoIncrement: true,
          keyPath: "id",
        });
      };
      request.onsuccess = (e) => {
        if (e == null || e.target == null) {
          logger.log("Db opened succesfully, but null");
          resolve(null);
        } else {
          DB = (e.target as IDBOpenDBRequest).result;
          resolve((e.target as IDBOpenDBRequest).result);
        }
      };
    });
  };

  const deletePermit = async (
    id: number,
    currentUser: string
  ): Promise<void> => {
    let db = await getDB(currentUser.toLowerCase());
    if (db == null) {
      return Promise.reject("No DB... get stored");
    }
    if (
      db.objectStoreNames.contains(PERMIT_NAME + currentUser.toLowerCase()) ==
      false
    ) {
      logger.log("Upgrade db version here", db.version, db.version + 1);
      db = await getDB(currentUser.toLowerCase(), db.version + 1);
      // logger.log("after upgrading", db == null);
    } else {
      logger.log("Upgrade not needed");
    }
    return new Promise((resolve) => {
      if (db == null) {
        return Promise.reject("No DB... get stored");
      }
      const trans = db.transaction(
        [PERMIT_NAME + currentUser.toLowerCase()],
        "readwrite"
      );
      trans.oncomplete = () => {
        resolve();
      };
      const store = trans.objectStore(PERMIT_NAME + currentUser.toLowerCase());
      store.delete(id);
    });
  };
  const getStoredPermits = async (
    currentUser: string
  ): Promise<OfflinePermitType[]> => {
    let db = await getDB(currentUser.toLowerCase());
    if (db == null) {
      return Promise.reject("No DB... get stored");
    }
    if (
      db.objectStoreNames.contains(PERMIT_NAME + currentUser.toLowerCase()) ==
      false
    ) {
      logger.log("Upgrade db version here", db.version, db.version + 1);
      db = await getDB(currentUser.toLowerCase(), db.version + 1);
      logger.log("after upgrading", db == null);
    } else {
      logger.log("Upgrade not needed");
    }
    // logger.log("Carry on");
    return new Promise((resolve, reject) => {
      if (db == null) {
        return reject("No DB... get storeed after upgrade");
      }
      const trans = db.transaction(
        [PERMIT_NAME + currentUser.toLowerCase()],
        "readwrite"
      );
      trans.onabort = () => {
        logger.log("Abort transactions");
      };
      trans.onerror = () => {
        logger.log("Error for stored permits on error");
      };
      trans.oncomplete = () => {
        // logger.log("Trans complete");
        return resolve(permits);
      };

      // logger.log("before store object store");
      let store;
      try {
        store = trans.objectStore(PERMIT_NAME + currentUser.toLowerCase());
      } catch (e) {
        logger.log("Should create new table here");
        store = db.createObjectStore(PERMIT_NAME + currentUser.toLowerCase());
      }

      const permits: OfflinePermitType[] = [];

      store.openCursor().onsuccess = (e) => {
        const cursor = (e.target as IDBRequest).result;
        if (cursor) {
          // logger.log("Here is saved permit: ", cursor);
          permits.push(cursor.value);
          cursor.continue();
        }
      };
    });
  };

  const savePermit = async (
    item: OfflinePermitType,
    currentUser: string
  ): Promise<void> => {
    let db = await getDB(currentUser.toLowerCase());
    if (db == null) {
      return Promise.reject("No DB... get stored");
    }
    if (
      db.objectStoreNames.contains(PERMIT_NAME + currentUser.toLowerCase()) ==
      false
    ) {
      logger.log("Upgrade db version here", db.version, db.version + 1);
      db = await getDB(currentUser.toLowerCase(), db.version + 1);
      logger.log("after upgrading", db == null);
    } else {
      logger.log("Upgrade not needed");
    }
    return new Promise((resolve, reject) => {
      if (db == null) {
        return reject("No DB... save permit after upgrade");
      }
      const trans = db.transaction(
        [PERMIT_NAME + currentUser.toLowerCase()],
        "readwrite"
      );
      trans.oncomplete = () => {
        resolve();
      };
      const store = trans.objectStore(PERMIT_NAME + currentUser.toLowerCase());
      store.put(item);
    });
  };
  return {
    getDB,
    savePermit,
    getStoredPermits,
    deletePermit,
    createObjectStore,
    unmountDB,
    DB,
    getAllUsers,
  };
};
const temp = indexedDb();
export default temp;
